export default "__VITE_ASSET__BrfH6BAo__"